import styled from 'styled-components';
import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  root: {
    fontSize: '16px',
  },
});

export const ProgressContainer = styled.div`
  margin-left: 210px;
  margin-top: 70px;
`;

export const ButtonContainer = styled.div`
  margin-top: 24px;
`;

export const StyledSaveButtonContainer = styled.span`
  padding: 18px 0;
  .MuiButton-contained {
    margin: 0;
  }
`;

export const StyledUnmapModeratorLinkContainer = styled.div`
  text-align: right;
  margin-top: -1em;
  .MuiButton-label {
    font-size: 16px;
  }
`;

export const StyledContainer = styled.div`
  max-width: 1254px;
  width: 100;
  margin-right: 24px;
  font-family: SourceSansPro;
`;

export const StyledHeaderRow = styled.div`
  display: flex;
  margin-bottom: 15px;
  padding: 0 8px;
`;

export const StyledHeaderCell = styled.div<{ maxWidth?: string }>`
  font-weight: bold;
  font-size: 16px;
  flex: 1;
  line-height: 24px;
  padding-top: 6px;
  max-width: ${({ maxWidth }): string => maxWidth || '100%'};
`;

export const StyledSmartSearch = styled.div`
  margin: 0.5em 0 0 0;
`;

export const StyledParagraph = styled.p`
  line-height: 1.5;
  font-size: 20px;
  font-family: SourceSansPro;
  margin: 1.2em 0 0 0;
`;

export const StyledCentreViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 1080px;
  margin: 24px 33px 0 0;
  padding: 32px 32px 32px 31.5px;
  border-radius: 16px;
  box-shadow: inset 0 -2px 0 0 var(--grey-2);
  border: solid 2px #f4f5f6;
  background-color: #fff;
`;

export const StyledCentreTitle = styled.p`
  font-family: BlissPro;
  font-size: 20px;
  font-weight: bold;
  margin: 0 0 0.25em 0;
`;

export const StyledCentreListItem = styled.li`
  font-family: BlissPro;
  font-size: 16px;
  font-weight: bold;
  padding: 0.25em;
`;

export const StyledOrderedList = styled.ol`
  margin: 0;
  padding-left: 1em;
`;

export const StyledModeratorList = styled.div`
  width: 464px;
  position: absolute;
  list-style-type: none;
  margin: -20px 0 0 0;
  border-radius: 10px;
  box-shadow: 0 1px 14px 0 rgba(206, 212, 217, 0.12), 0 5px 8px 0 rgba(206, 212, 217, 0.14),
    0 3px 5px -1px rgba(206, 212, 217, 0.2);
  border: solid 2px #f5f6f7;
  background-color: white;
`;

export const StyledModeratorListItem = styled.div`
  cursor: pointer;
  padding: 17px 16px;
  font-family: SourceSansPro;
  font-size: 20px;
  line-height: 1.5;
  color: #474747;
`;
